import script from "./Equipment.vue?vue&type=script&setup=true&lang=js"
export * from "./Equipment.vue?vue&type=script&setup=true&lang=js"

import "./Equipment.vue?vue&type=style&index=0&id=64a48fed&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a48fed"]])

export default __exports__